import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { PlayerYearLookup } from '../../api/models';

export type TABLE_TYPE = Table<PlayerYearLookup>;

export const TABLE = 'playerYearLookup';
const SCHEMA = 'playerYearLookupId, sortId';

class PlayerYearLookupDatabase implements DataRepository<PlayerYearLookup> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  get(key: Key): Promise<PlayerYearLookup | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: PlayerYearLookup, key: Key): Promise<PlayerYearLookup> {
    return this.db[TABLE].put(payload, key);
  }

  async bulkAdd(payload: PlayerYearLookup[]): Promise<PlayerYearLookup[]> {
    await this.db[TABLE].clear();
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<PlayerYearLookup[]> {
    return this.db[TABLE].orderBy('sortId').toArray();
  }
}

export const PlayerYearLookupDB = new PlayerYearLookupDatabase(db);
